<app-cmn-header [config]="{title: 'SS&C Alerting'}"></app-cmn-header>
<div class="user fixed top-0 right-4 h-[61px] flex items-center gap-2 z-[300]">
    <mat-slide-toggle (change)="onToggleAdmin($event)" *ngIf="this.isTrueAdmin()" [checked]="this.isAdminOn()"
                      class="toggle" color="primary"
                      matTooltip="For Admins only, toggle to non-admin mode"></mat-slide-toggle>
    <a class="user-profile-button no-hyperlink-styling inline-flex items-center !static" routerLink="user-profile">
        <mat-icon matTooltip="User Profile">account_circle</mat-icon>
    </a>
</div>
<div *ngIf="shouldDisplayAnnouncement()" class="news cmn-flex row space-between align-center" [ngStyle]="{'background-color': announcement.color.value}">
    <span class="padded-left" markdown>{{announcement.current}}</span>
    <button (click)="dismissAnnouncement(announcement.current)" aria-label="Dismiss announcement" class="right news-close-button" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>
<app-cmn-sidebar [opened]="isOpen" (openedChange)="onSidebarToggled($event)" [config]="{width: '210px', closedWidth: '43px'}" class="cmn-style full-height alert-cmn-sidebar">
    <ng-container class="side">
        <div class="cmn-button mat-stroked-button firstbtn" [matTooltip]="isOpen ? null : 'Send Message'" routerLink="sendMessage"
             routerLinkActive="active">
            <mat-icon>textsms</mat-icon>
            <span *ngIf="isOpen">Send Message</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Message Status'" routerLink="messageMonitor"
             routerLinkActive="active">
            <mat-icon>history</mat-icon>
            <span *ngIf="isOpen">Message Status</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Message Status V2'" routerLink="messageStatusV2"
             routerLinkActive="active">
            <mat-icon>history</mat-icon>
            <span *ngIf="isOpen">Message Status V2</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Templates'" routerLink="templates"
             routerLinkActive="active">
            <mat-icon>notes</mat-icon>
            <span *ngIf="isOpen">Templates</span>
        </div>
        <div *ngIf="isAdminOn()" class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Individuals'" routerLink="individuals"
             routerLinkActive="active">
            <mat-icon>person</mat-icon>
            <span *ngIf="isOpen">Individuals</span>
        </div>
        <div *ngIf="!isAdminOn()" class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'User Profile'" routerLink="user-profile"
             routerLinkActive="active">
            <mat-icon>person</mat-icon>
            <span *ngIf="isOpen">User Profile</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Channels'" routerLink="channels"
             routerLinkActive="active">
            <mat-icon>devices</mat-icon>
            <span *ngIf="isOpen">Channels</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Groups'" routerLink="groups"
             routerLinkActive="active">
            <mat-icon>supervisor_account</mat-icon>
            <span *ngIf="isOpen">Groups</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Groups'" routerLink="who"
             routerLinkActive="active">
            <mat-icon>search</mat-icon>
            <span *ngIf="isOpen">SSC Who</span>
        </div>
        <div *ngIf="isAdminOn()" class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'Admin Settings'" routerLink="settings"
             routerLinkActive="active">
            <mat-icon>settings</mat-icon>
            <span *ngIf="isOpen">Settings</span>
        </div>
        <div class="cmn-button mat-stroked-button" [matTooltip]="isOpen ? null : 'FAQ'" routerLink="faq"
             routerLinkActive="active">
            <mat-icon>help</mat-icon>
            <span *ngIf="isOpen">FAQ</span>
        </div>
        <app-dark-mode-toggle *ngIf="isOpen"></app-dark-mode-toggle>
    </ng-container>
    <ng-container class="content">
        <router-outlet></router-outlet>
    </ng-container>
</app-cmn-sidebar>
